import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
// -- components --
import { IntroductionComponent } from '../../introduction/introduction.component';
import { JumpstartGuideComponent } from '../../jumpstart-guide/jumpstart-guide.component';
import { CapacityBuildingComponent } from '../../capacity-building/capacity-building.component';
import { CertificationComponent } from '../../certification/certification.component';
import { FinancingSolutionsComponent } from '../../financing-solutions/financing-solutions.component';
// -- services --
import { TabNavigationService } from '../../services/tab-navigation.service';
import { Jc3Service } from '../../jc3.service';

@Component({
    selector: 'app-main-tabs',
    standalone: true,
    imports: [
        CommonModule,
        IntroductionComponent,
        JumpstartGuideComponent,
        CapacityBuildingComponent,
        CertificationComponent,
        FinancingSolutionsComponent,
    ],
    templateUrl: './main-tabs.component.html',
    styleUrl: './main-tabs.component.scss',
})
export class MainTabsComponent implements OnInit, OnDestroy {
    private subscription = new Subscription();
    tabsAPIData: any = [];
    tabs = [
        {
            title: 'Introduction',
            slug: 'introduction',
            ga_id: 'introduction_button_jc3_click',
            ga_label: 'Introduction Button Click',
            ga_category: 'JC3 Button',
        },
        {
            title: 'Jumpstart Guide',
            slug: 'jumpstart-guide',
            ga_id: 'jumpstart_guide_button_jc3_click',
            ga_label: 'Jumpstart Guide Button Click',
            ga_category: 'JC3 Button',
        },
        {
            title: 'Capacity Building, Tools & Resources',
            slug: 'capacity-building',
            ga_id: 'capacity_building_resources_tools_button_jc3_click',
            ga_label: 'Capacity Building, Resources & Tools Button Click',
            ga_category: 'JC3 Button',
        },
        {
            title: 'Certification',
            slug: 'certification',
            ga_id: 'certifications_button_jc3_click',
            ga_label: 'Certifications Button Click',
            ga_category: 'JC3 Button',
        },
        {
            title: 'Financing Solutions',
            slug: 'financing-solutions',
            ga_id: 'financing_solutions_button_jc3_click',
            ga_label: 'Financing Solutions Button Click',
            ga_category: 'JC3 Button',
        },
    ];

    activeTab = 'introduction';

    constructor(
        private tabNavigationService: TabNavigationService,
        private _jc3Service: Jc3Service
    ) {}

    ngOnInit() {
        this.subscription.add(
            this.tabNavigationService.mainTab$.subscribe((tab) => {
                this.activeTab = tab;
            })
        );
        this.getSwitcherAPIData();
    }

    getSwitcherAPIData() {
        this._jc3Service.getSwitcher().subscribe({
            next: (res) => {
                this.tabsAPIData = res.find(
                    (item: { title1?: string }) => item.title1
                );
                this.tabs = this.tabs?.map((tabListItem, index) => {
                    const tabData = { ...tabListItem };
                    tabData.title = this.tabsAPIData[`title${index + 1}`];
                    return tabData;
                });
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    setActive(tab: string) {
        this.tabNavigationService.navigateToTab(tab);
    }
}
